// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"5317d4f4","122":"042ad0e4","223":"3021fd4e","465":"072de578","541":"348ee0b0","787":"8eb8651a"}[chunkId] + ".chunk.js";
};